import Phaser from 'phaser';

interface LoaderPluginPlus extends Phaser.Loader.LoaderPlugin { };

let unloadMixin = {
  unloadPack() {
    console.log('Unload!');
  }
};

Object.assign(Phaser.Loader.LoaderPlugin.prototype, unloadMixin);
